export const MOBILE_NUMBER = '0000000000';
export const EMAIL = 'xyz@gmail.com';

// Personal Details Placeholders
export const FIRST_NAME = 'First Name';
export const LAST_NAME = 'Last Name';
export const PAN_NUMBER = 'PAN Number';

// Address Details Placeholders
export const PINCODE = 'Pincode';
export const ROAD = 'Road/Area';
export const FLAT_NUMBER = 'Flat No. & Building Name';
export const LANDMARK = 'Landmark';

// BirthdayInput Component Placeholders
export const DAY = 'DAY';
export const YEAR = 'Year';

// Otpbox Component Placeholder
export const SINGLE_DIGIT = '0';

// devices
export const MOBILE = 'Mobile';
export const DESKTOP = 'Desktop';
